export const stringifyError = (error) => {
    const plainObject = {};
    Object.getOwnPropertyNames(error).forEach((key) => {
        plainObject[key] = error[key];
    });
    return JSON.stringify(plainObject, null, "\r\n");
};
